export const WEEK_DAYS = ['SU', 'MO', 'TU', 'WE', 'TH', 'FR', 'SA'];

export const CALENDAR_TYPE = 'ISO 8601';

export const CALENDAR_LOCALE = 'en-US';
